import React from 'react';

interface SectionSubtitleProps extends React.HTMLAttributes<HTMLParagraphElement> {
  text: React.ReactNode;
}

function SectionSubtitle({ text, className = '', ...props }: SectionSubtitleProps) {
  return (
    <p className={`text-sm text-gray-500 mt-1 ${className}`} {...props}>
      {text}
    </p>
  );
}

export default SectionSubtitle;
